export default function fetchNewAereoTermo(body) {
    return fetch(process.env.VUE_APP_API_ORIGIN + '/api/aereoTermo', {
        method: 'POST',
        body,
    });
}